{
    "v": "5.12.1",
    "fr": 60,
    "ip": 0,
    "op": 3000,
    "w": 1080,
    "h": 1920,
    "nm": "2025-08-18_Avec-SelfCheckout_All",
    "ddd": 0,
    "assets": [],
    "layers": [
        {
            "ddd": 0,
            "ind": 1,
            "ty": 4,
            "nm": "Avec 1",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [540, 655.768, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [49, 49, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0.814, -2.59],
                                        [0, 0],
                                        [0, 0],
                                        [2.753, 0],
                                        [0, 0],
                                        [1.174, -1.626],
                                        [-0.66, -1.89],
                                        [0, 0],
                                        [-2.679, 0],
                                        [0, 0],
                                        [-0.865, 2.508],
                                        [0, 0],
                                        [1.173, 1.626],
                                        [2.019, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [-2.751, 0],
                                        [0, 0],
                                        [0, 0],
                                        [-0.814, -2.59],
                                        [0, 0],
                                        [-2.03, 0],
                                        [-1.186, 1.625],
                                        [0, 0],
                                        [0.868, 2.499],
                                        [0, 0],
                                        [2.689, 0],
                                        [0, 0],
                                        [0.649, -1.889],
                                        [-1.185, -1.616],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [88.488, -94.61],
                                        [39.563, -94.61],
                                        [33.565, -90.253],
                                        [1.396, 12.493],
                                        [-30.785, -90.253],
                                        [-36.782, -94.61],
                                        [-88.488, -94.61],
                                        [-93.589, -92.021],
                                        [-94.423, -86.423],
                                        [-33.002, 90.424],
                                        [-27.065, 94.61],
                                        [27.764, 94.61],
                                        [33.71, 90.405],
                                        [94.434, -86.444],
                                        [93.589, -92.031],
                                        [88.488, -94.61],
                                        [88.488, -94.61]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
                            "o": { "a": 0, "k": 100, "ix": 5 },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [-104.741, 0.163], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [0, 0],
                                                [12.14, 6.237],
                                                [16.218, 0],
                                                [11.963, -5.1],
                                                [8.623, -8.878],
                                                [4.656, -12.109],
                                                [0, -13.936],
                                                [-4.525, -12.036],
                                                [-8.429, -8.797],
                                                [-12.128, -4.744],
                                                [-14.859, 0],
                                                [-15.333, 9.743],
                                                [-7.357, 22.511],
                                                [1.185, 1.595],
                                                [2.008, 0],
                                                [0, 0],
                                                [0.784, -2.631],
                                                [5.914, -4.041],
                                                [8.707, 0],
                                                [6.152, 5.883],
                                                [0.01, 0],
                                                [1.278, 10.717],
                                                [0, 0],
                                                [-0.216, 3.251],
                                                [3.378, 13.175],
                                                [7.708, 10.38],
                                                [0, 0]
                                            ],
                                            "o": [
                                                [-7.831, -10.534],
                                                [-12.189, -6.247],
                                                [-14.436, 0],
                                                [-11.953, 5.109],
                                                [-8.667, 8.909],
                                                [-4.648, 12.046],
                                                [0, 14.343],
                                                [4.533, 12.119],
                                                [8.47, 8.837],
                                                [12.005, 4.734],
                                                [21.476, 0],
                                                [15.528, -9.873],
                                                [0.617, -1.879],
                                                [-1.175, -1.605],
                                                [0, 0],
                                                [-2.783, 0],
                                                [-1.205, 4.064],
                                                [-6.184, 4.216],
                                                [-12.128, 0],
                                                [0, 0],
                                                [-5.174, -4.947],
                                                [0, 0],
                                                [3.298, 0],
                                                [0.979, -14.23],
                                                [-3.453, -13.276],
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            "v": [
                                                [75.007, -64.542],
                                                [44.908, -89.816],
                                                [2.104, -99.232],
                                                [-37.681, -91.542],
                                                [-68.685, -70.476],
                                                [-88.769, -38.802],
                                                [-95.777, 0.344],
                                                [-88.954, 40.113],
                                                [-69.429, 71.634],
                                                [-38.381, 92.101],
                                                [2.104, 99.232],
                                                [57.562, 84.553],
                                                [92.051, 35.755],
                                                [91.154, 30.219],
                                                [86.085, 27.67],
                                                [42.713, 27.67],
                                                [36.696, 32.119],
                                                [25.959, 44.338],
                                                [3.846, 50.596],
                                                [-23.709, 41.738],
                                                [-23.719, 41.738],
                                                [-33.435, 18.161],
                                                [89.195, 18.161],
                                                [95.451, 12.392],
                                                [91.825, -28.899],
                                                [75.007, -64.542],
                                                [75.007, -64.542]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": { "a": 0, "k": [89.961, 0], "ix": 2 },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 1",
                            "np": 1,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [0, 0],
                                                [-0.381, 1.29],
                                                [-2.608, 3.24],
                                                [-4.39, 2.204],
                                                [-6.833, 0],
                                                [-4.626, -5.008],
                                                [-2.153, -7.557],
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            "o": [
                                                [0.278, -1.199],
                                                [1.03, -3.524],
                                                [2.534, -3.15],
                                                [4.275, -2.164],
                                                [10.128, 0],
                                                [3.896, 4.214],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            "v": [
                                                [-32.495, 12.626],
                                                [-31.506, 8.898],
                                                [-26.024, -1.3],
                                                [-15.585, -9.376],
                                                [1.159, -12.626],
                                                [23.405, -5.078],
                                                [32.495, 12.626],
                                                [-32.495, 12.626],
                                                [-32.495, 12.626]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [89.526, -37.625],
                                        "ix": 2
                                    },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 2",
                            "np": 1,
                            "cix": 2,
                            "bm": 0,
                            "ix": 2,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "mm",
                            "mm": 5,
                            "nm": "Merge Paths 1",
                            "mn": "ADBE Vector Filter - Merge",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
                            "o": { "a": 0, "k": 100, "ix": 5 },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 2",
                    "np": 4,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [0, 0],
                                                [0, 7.74],
                                                [0, 0],
                                                [5.647, 7.558],
                                                [8.532, 4.073],
                                                [9.892, 1.331],
                                                [19.424, -3.809],
                                                [8.398, -4.876],
                                                [5.594, -8.278],
                                                [0.772, -12.453],
                                                [-1.185, -1.239],
                                                [-1.731, 0],
                                                [0, 0],
                                                [-0.298, 3.18],
                                                [-4.071, 2.996],
                                                [-8.285, 0],
                                                [-3.524, -0.517],
                                                [-2.175, -1.29],
                                                [-1.205, -2.153],
                                                [-0.01, -4.378],
                                                [1.041, -0.843],
                                                [4.608, -1.127],
                                                [6.883, -0.659],
                                                [7.533, -1.147],
                                                [7.399, -1.971],
                                                [6.224, -4.267],
                                                [4.019, -7.304],
                                                [0, -11.02],
                                                [-3.492, -7.395],
                                                [-6.295, -4.906],
                                                [-8.223, -2.286],
                                                [-9.057, 0],
                                                [-11.211, 3.362],
                                                [-6.472, 4.723],
                                                [-0.783, -2.296],
                                                [-2.701, 0],
                                                [0, 0],
                                                [-1.102, 1.971],
                                                [1.216, 1.91],
                                                [1.01, 7.943],
                                                [0, 0]
                                            ],
                                            "o": [
                                                [-0.886, -6.958],
                                                [0, 0],
                                                [0, -12.007],
                                                [-5.43, -7.272],
                                                [-8.172, -3.92],
                                                [-20.031, -2.711],
                                                [-10.51, 2.082],
                                                [-8.666, 5.017],
                                                [-5.678, 8.411],
                                                [-0.104, 1.707],
                                                [1.185, 1.239],
                                                [0, 0],
                                                [3.236, 0],
                                                [0.742, -7.719],
                                                [4.409, -3.27],
                                                [4.007, 0],
                                                [3.01, 0.458],
                                                [1.937, 1.138],
                                                [1.185, 2.093],
                                                [0.175, 3.982],
                                                [-2.513, 2.031],
                                                [-5.172, 1.279],
                                                [-7.285, 0.702],
                                                [-7.655, 1.188],
                                                [-7.964, 2.123],
                                                [-6.471, 4.428],
                                                [-4.07, 7.384],
                                                [0, 9.996],
                                                [3.524, 7.476],
                                                [6.142, 4.805],
                                                [7.954, 2.195],
                                                [11.645, 0],
                                                [7.811, -2.336],
                                                [0.556, 2.376],
                                                [0.855, 2.519],
                                                [0, 0],
                                                [2.288, 0],
                                                [1.101, -1.96],
                                                [-1.237, -1.95],
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            "v": [
                                                [88.805, 71.396],
                                                [87.475, 49.242],
                                                [87.475, -42.778],
                                                [78.963, -72.267],
                                                [57.912, -89.372],
                                                [30.687, -97.295],
                                                [-28.469, -96.218],
                                                [-56.96, -85.736],
                                                [-78.444, -65.704],
                                                [-88.161, -34.256],
                                                [-86.462, -29.644],
                                                [-81.897, -27.694],
                                                [-32.622, -27.694],
                                                [-26.378, -33.301],
                                                [-19.132, -49.452],
                                                [-0.008, -54.378],
                                                [11.357, -53.596],
                                                [19.158, -50.976],
                                                [23.836, -46.08],
                                                [25.659, -36.337],
                                                [23.434, -29.939],
                                                [12.706, -25.175],
                                                [-5.469, -22.25],
                                                [-27.697, -19.466],
                                                [-50.387, -14.711],
                                                [-71.767, -5.092],
                                                [-87.575, 12.593],
                                                [-93.716, 40.343],
                                                [-88.45, 66.561],
                                                [-73.643, 85.221],
                                                [-52.004, 95.907],
                                                [-26.378, 99.218],
                                                [8.07, 94.15],
                                                [29.535, 83.535],
                                                [31.533, 90.533],
                                                [37.479, 94.759],
                                                [87.444, 94.759],
                                                [92.937, 91.558],
                                                [92.751, 85.281],
                                                [88.805, 71.396],
                                                [88.805, 71.396]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [-300.499, 0.014],
                                        "ix": 2
                                    },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 1",
                            "np": 1,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "ind": 0,
                                    "ty": "sh",
                                    "ix": 1,
                                    "ks": {
                                        "a": 0,
                                        "k": {
                                            "i": [
                                                [0, 0],
                                                [0, 0],
                                                [0.526, -4.235],
                                                [2.133, -3.728],
                                                [4.359, -2.61],
                                                [8.502, 0],
                                                [3.277, 0.61],
                                                [2.102, 1.3],
                                                [1.113, 2.032],
                                                [0, 3.311],
                                                [-1.113, 2.022],
                                                [-1.917, 1.401],
                                                [-2.927, 0.925],
                                                [-3.36, 0.61],
                                                [-3.814, 0.437],
                                                [-3.741, 0.701],
                                                [-3.235, 1.036],
                                                [0, 0]
                                            ],
                                            "o": [
                                                [0, 0],
                                                [0, 2.549],
                                                [-0.475, 3.728],
                                                [-1.999, 3.493],
                                                [-4.318, 2.581],
                                                [-3.555, 0],
                                                [-2.917, -0.538],
                                                [-1.855, -1.147],
                                                [-1.102, -2.011],
                                                [0, -3.526],
                                                [1.185, -2.175],
                                                [2.112, -1.534],
                                                [3.307, -1.056],
                                                [3.823, -0.661],
                                                [4.1, -0.478],
                                                [3.679, -0.712],
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            "v": [
                                                [28.77, -21.179],
                                                [28.77, -13.337],
                                                [27.956, -3.159],
                                                [24.03, 8.076],
                                                [14.447, 17.288],
                                                [-4.864, 21.179],
                                                [-15.158, 20.264],
                                                [-22.711, 17.502],
                                                [-27.111, 12.788],
                                                [-28.77, 4.785],
                                                [-27.1, -3.566],
                                                [-22.484, -8.878],
                                                [-14.9, -12.586],
                                                [-4.822, -15.114],
                                                [6.626, -16.771],
                                                [18.362, -18.548],
                                                [28.77, -21.179],
                                                [28.77, -21.179]
                                            ],
                                            "c": true
                                        },
                                        "ix": 2
                                    },
                                    "nm": "Path 1",
                                    "mn": "ADBE Vector Shape - Group",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [-303.62, 33.521],
                                        "ix": 2
                                    },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Group 2",
                            "np": 1,
                            "cix": 2,
                            "bm": 0,
                            "ix": 2,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "mm",
                            "mm": 5,
                            "nm": "Merge Paths 1",
                            "mn": "ADBE Vector Filter - Merge",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
                            "o": { "a": 0, "k": 100, "ix": 5 },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 3",
                    "np": 4,
                    "cix": 2,
                    "bm": 0,
                    "ix": 3,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [1.812, 0],
                                        [0, 0],
                                        [0.452, -3.037],
                                        [5.4, -5.506],
                                        [10.109, 0],
                                        [4.267, 2.743],
                                        [2.659, 4.571],
                                        [1.248, 5.962],
                                        [0, 5.922],
                                        [-1.31, 6.309],
                                        [-2.989, 4.988],
                                        [-4.513, 2.997],
                                        [-6.563, 0],
                                        [-2.76, -17.197],
                                        [-3.082, 0],
                                        [0, 0],
                                        [-1.185, 1.249],
                                        [0.103, 1.697],
                                        [5.329, 9.112],
                                        [8.419, 6.084],
                                        [10.479, 2.916],
                                        [11.15, 0],
                                        [12.076, -5.1],
                                        [8.419, -9.153],
                                        [4.287, -12.473],
                                        [0, -14.311],
                                        [-4.658, -11.722],
                                        [-8.407, -8.532],
                                        [-12.005, -4.754],
                                        [-14.156, 0],
                                        [-16.353, 13.186],
                                        [-3.451, 24.977],
                                        [1.185, 1.341],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [-1.194, -1.351],
                                        [0, 0],
                                        [-3.114, 0],
                                        [-1.433, 9.599],
                                        [-5.172, 5.282],
                                        [-6.369, 0],
                                        [-4.503, -2.894],
                                        [-2.783, -4.734],
                                        [-1.298, -6.186],
                                        [0, -6.145],
                                        [1.225, -5.994],
                                        [2.864, -4.774],
                                        [4.247, -2.814],
                                        [17.868, 0],
                                        [0.474, 3.007],
                                        [0, 0],
                                        [1.733, 0],
                                        [1.185, -1.24],
                                        [-0.752, -12.322],
                                        [-5.275, -9.031],
                                        [-8.348, -6.004],
                                        [-10.356, -2.875],
                                        [-15.355, 0],
                                        [-12.128, 5.129],
                                        [-8.429, 9.152],
                                        [-4.255, 12.322],
                                        [0, 13.948],
                                        [4.688, 11.783],
                                        [8.419, 8.564],
                                        [11.912, 4.734],
                                        [25.215, 0],
                                        [16.445, -13.276],
                                        [0.248, -1.767],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [93.216, 16.801],
                                        [88.486, 14.678],
                                        [40.952, 14.678],
                                        [34.749, 19.971],
                                        [24.454, 42.744],
                                        [1.744, 50.596],
                                        [-14.28, 46.461],
                                        [-24.924, 35.38],
                                        [-30.983, 19.259],
                                        [-32.942, 1.016],
                                        [-30.971, -17.756],
                                        [-24.614, -34.303],
                                        [-13.496, -46.015],
                                        [2.784, -50.251],
                                        [33.028, -25.039],
                                        [39.222, -19.817],
                                        [87.444, -19.817],
                                        [92.009, -21.768],
                                        [93.71, -26.37],
                                        [84.549, -58.672],
                                        [63.911, -81.445],
                                        [35.542, -94.895],
                                        [3.125, -99.232],
                                        [-38.217, -91.542],
                                        [-69.181, -70.007],
                                        [-88.347, -37.402],
                                        [-94.757, 2.732],
                                        [-87.738, 41.414],
                                        [-68.006, 72.029],
                                        [-37.216, 92.101],
                                        [2.083, 99.232],
                                        [64.714, 79.352],
                                        [94.698, 21.697],
                                        [93.216, 16.801],
                                        [93.216, 16.801]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
                            "o": { "a": 0, "k": 100, "ix": 5 },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [299.458, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 4",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 4,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 4500,
            "st": 0,
            "ct": 1,
            "cp": true,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 2,
            "ty": 4,
            "nm": "Ellipse 1",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": [0.833], "y": [0.833] },
                            "o": { "x": [0.167], "y": [0.167] },
                            "t": 0,
                            "s": [169.776]
                        },
                        {
                            "i": { "x": [0.833], "y": [0.833] },
                            "o": { "x": [0.167], "y": [0.167] },
                            "t": 394,
                            "s": [195.776]
                        },
                        {
                            "i": { "x": [0.833], "y": [0.833] },
                            "o": { "x": [0.167], "y": [0.167] },
                            "t": 988,
                            "s": [222.776]
                        },
                        {
                            "i": { "x": [0.833], "y": [0.833] },
                            "o": { "x": [0.167], "y": [0.167] },
                            "t": 1468,
                            "s": [172.776]
                        },
                        { "t": 3000, "s": [169.776] }
                    ],
                    "ix": 10
                },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": 0.833, "y": 0.833 },
                            "o": { "x": 0.167, "y": 0.167 },
                            "t": 0,
                            "s": [841.037, 1770.936, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.833, "y": 0.833 },
                            "o": { "x": 0.167, "y": 0.167 },
                            "t": 315,
                            "s": [765.037, 1786.936, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.833, "y": 0.833 },
                            "o": { "x": 0.167, "y": 0.167 },
                            "t": 1622,
                            "s": [699.037, 2512.936, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        { "t": 3000, "s": [841.037, 1770.936, 0] }
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [55, 55, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "d": 1,
                            "ty": "el",
                            "s": { "a": 0, "k": [4505.021, 2954.223], "ix": 2 },
                            "p": { "a": 0, "k": [0, 0], "ix": 3 },
                            "nm": "Ellipse Path 1",
                            "mn": "ADBE Vector Shape - Ellipse",
                            "hd": false
                        },
                        {
                            "ty": "gs",
                            "o": { "a": 0, "k": 100, "ix": 9 },
                            "w": { "a": 0, "k": 5, "ix": 10 },
                            "g": {
                                "p": 3,
                                "k": {
                                    "a": 0,
                                    "k": [
                                        0, 1, 1, 1, 0.77, 1, 1, 1, 1, 1, 1, 1,
                                        0, 0.15, 0.77, 0.075, 1, 0
                                    ],
                                    "ix": 8
                                }
                            },
                            "s": {
                                "a": 0,
                                "k": [1518.429, -1264.071],
                                "ix": 4
                            },
                            "e": {
                                "a": 0,
                                "k": [-1517.625, 1263.351],
                                "ix": 5
                            },
                            "t": 1,
                            "lc": 1,
                            "lj": 1,
                            "ml": 10,
                            "ml2": { "a": 0, "k": 10, "ix": 13 },
                            "bm": 0,
                            "nm": "Gradient Stroke 1",
                            "mn": "ADBE Vector Graphic - G-Stroke",
                            "hd": false
                        },
                        {
                            "ty": "gf",
                            "o": { "a": 0, "k": 100, "ix": 10 },
                            "r": 1,
                            "bm": 0,
                            "g": {
                                "p": 3,
                                "k": {
                                    "a": 0,
                                    "k": [
                                        0, 1, 1, 1, 0.77, 1, 1, 1, 1, 1, 1, 1,
                                        0, 0.15, 0.77, 0.075, 1, 0
                                    ],
                                    "ix": 9
                                }
                            },
                            "s": { "a": 0, "k": [-579.151, 1491.402], "ix": 5 },
                            "e": { "a": 0, "k": [579.653, -1492.519], "ix": 6 },
                            "t": 1,
                            "nm": "Gradient Fill 1",
                            "mn": "ADBE Vector Graphic - G-Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 4500,
            "st": 0,
            "ct": 1,
            "cp": true,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 3,
            "ty": 4,
            "nm": "Ellipse",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": [0.833], "y": [0.833] },
                            "o": { "x": [0.167], "y": [0.167] },
                            "t": 0,
                            "s": [258.498]
                        },
                        {
                            "i": { "x": [0.833], "y": [0.833] },
                            "o": { "x": [0.167], "y": [0.167] },
                            "t": 339,
                            "s": [282.498]
                        },
                        {
                            "i": { "x": [0.833], "y": [0.833] },
                            "o": { "x": [0.167], "y": [0.167] },
                            "t": 1852,
                            "s": [265.498]
                        },
                        {
                            "i": { "x": [0.833], "y": [0.833] },
                            "o": { "x": [0.167], "y": [0.167] },
                            "t": 2469,
                            "s": [312.498]
                        },
                        { "t": 2990, "s": [258.498] }
                    ],
                    "ix": 10
                },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": 0.833, "y": 0.833 },
                            "o": { "x": 0.167, "y": 0.167 },
                            "t": 0,
                            "s": [611.253, 1771.165, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.833, "y": 0.833 },
                            "o": { "x": 0.167, "y": 0.167 },
                            "t": 240,
                            "s": [557.253, 1755.165, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.833, "y": 0.833 },
                            "o": { "x": 0.167, "y": 0.167 },
                            "t": 1156,
                            "s": [477.253, 2847.165, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.833, "y": 0.833 },
                            "o": { "x": 0.167, "y": 0.167 },
                            "t": 1917,
                            "s": [709.253, 1779.165, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.833, "y": 0.833 },
                            "o": { "x": 0.167, "y": 0.167 },
                            "t": 2414,
                            "s": [637.253, 2527.165, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        { "t": 2990, "s": [611.253, 1771.165, 0] }
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [70, 70, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "d": 1,
                            "ty": "el",
                            "s": { "a": 0, "k": [2666.901, 4967.943], "ix": 2 },
                            "p": { "a": 0, "k": [0, 0], "ix": 3 },
                            "nm": "Ellipse Path 1",
                            "mn": "ADBE Vector Shape - Ellipse",
                            "hd": false
                        },
                        {
                            "ty": "gs",
                            "o": { "a": 0, "k": 100, "ix": 9 },
                            "w": { "a": 0, "k": 5, "ix": 10 },
                            "g": {
                                "p": 3,
                                "k": {
                                    "a": 0,
                                    "k": [
                                        0, 1, 1, 1, 0.77, 1, 1, 1, 1, 1, 1, 1,
                                        0, 0.15, 0.77, 0.075, 1, 0
                                    ],
                                    "ix": 8
                                }
                            },
                            "s": { "a": 0, "k": [1355.881, 202.972], "ix": 4 },
                            "e": { "a": 0, "k": [-1357.609, -202.64], "ix": 5 },
                            "t": 1,
                            "lc": 1,
                            "lj": 1,
                            "ml": 10,
                            "ml2": { "a": 0, "k": 10, "ix": 13 },
                            "bm": 0,
                            "nm": "Gradient Stroke 1",
                            "mn": "ADBE Vector Graphic - G-Stroke",
                            "hd": false
                        },
                        {
                            "ty": "gf",
                            "o": { "a": 0, "k": 100, "ix": 10 },
                            "r": 1,
                            "bm": 0,
                            "g": {
                                "p": 3,
                                "k": {
                                    "a": 0,
                                    "k": [
                                        0, 1, 1, 1, 0.77, 1, 1, 1, 1, 1, 1, 1,
                                        0, 0.15, 0.77, 0.075, 1, 0
                                    ],
                                    "ix": 9
                                }
                            },
                            "s": { "a": 0, "k": [864.744, 2197.741], "ix": 5 },
                            "e": {
                                "a": 0,
                                "k": [-867.024, -2198.973],
                                "ix": 6
                            },
                            "t": 1,
                            "nm": "Gradient Fill 1",
                            "mn": "ADBE Vector Graphic - G-Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 4500,
            "st": 0,
            "ct": 1,
            "cp": true,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 4,
            "ty": 4,
            "nm": "Red BG",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [540, 960, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [559.75, 1218.25, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [-559.5, 1218],
                                        [559.5, 1218],
                                        [559.5, -1218],
                                        [-559.5, -1218]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [1, 0, 0.349019607843, 1],
                                "ix": 4
                            },
                            "o": { "a": 0, "k": 100, "ix": 5 },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [559.75, 1218.25], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 3088,
            "st": 0,
            "ct": 1,
            "cp": true,
            "bm": 0
        }
    ],
    "markers": [],
    "props": {}
}
